/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Donate_Plan_PowerInputs */

const en_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contribute 
${i?.number} Forest Power`)
};

const ar_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ساهم 
${i?.number} قوة Forest`)
};

const de_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trage bei 
${i?.number} Forest Power`)
};

const es_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contribuir con ${i?.number} de poder del bosque`)
};

const fr_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contribuer 
${i?.number} Pouvoir Forest`)
};

const it_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contribuisci con
${i?.number} Forest Power`)
};

const ja_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}Forestパワー
で貢献`)
};

const ko_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Forest Power 기부하기`)
};

const pt_br_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contribua com
${i?.number} de Poder do Forest`)
};

const ru_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Внесение 
${i?.number} силы Forest`)
};

const th_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`มีส่วนร่วมในการเพิ่ม
${i?.number} พลังแห่ง Forest`)
};

const tr_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Katkıda Bulun 
${i?.number} Forest Gücü`)
};

const zh_cn_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`捐赠
${i?.number} 森林能量`)
};

const zh_tw_earth_day_2025_donate_plan_power = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`捐贈
${i?.number} 森林能量`)
};

/**
* | output |
* | --- |
* | "Contribute {number} Forest Power" |
*
* @param {Earth_Day_2025_Donate_Plan_PowerInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_donate_plan_power = /** @type {((inputs: Earth_Day_2025_Donate_Plan_PowerInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Donate_Plan_PowerInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_donate_plan_power(inputs)
	if (locale === "ar") return ar_earth_day_2025_donate_plan_power(inputs)
	if (locale === "de") return de_earth_day_2025_donate_plan_power(inputs)
	if (locale === "es") return es_earth_day_2025_donate_plan_power(inputs)
	if (locale === "fr") return fr_earth_day_2025_donate_plan_power(inputs)
	if (locale === "it") return it_earth_day_2025_donate_plan_power(inputs)
	if (locale === "ja") return ja_earth_day_2025_donate_plan_power(inputs)
	if (locale === "ko") return ko_earth_day_2025_donate_plan_power(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_donate_plan_power(inputs)
	if (locale === "ru") return ru_earth_day_2025_donate_plan_power(inputs)
	if (locale === "th") return th_earth_day_2025_donate_plan_power(inputs)
	if (locale === "tr") return tr_earth_day_2025_donate_plan_power(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_donate_plan_power(inputs)
	return zh_tw_earth_day_2025_donate_plan_power(inputs)
});